const reportFailed = (input, validationFail) => {
  if (validationFail.result === true) {
    console.error(
      `Field ${validationFail.type} failed the ${validationFail.check} validation rules.`
    );
  } else {
    const resultsValid = input.validity;
    let errors = [];
    for (var key in resultsValid) {
      if (resultsValid[key]) {
        if (key !== "valid") {
          errors.push(key);
        }
      }
    }

    errors.forEach((error) => {
      console.error(
        `Input value ${input.value} for field ${validationFail.type} failed ${error} check.`
      );
    });
  }
};

const validationResult = (check, result, type, input, custom) => {
  return {
    check: check,
    result: result,
    type: type,
    input: input,
    custom: custom,
  };
};

const validField = (inputEl) => {
  if (inputEl.classList.contains("invalidated")) {
    inputEl.classList.remove("invalidated");
  }
};
/*----//  Input Field: Validation Messaging   //----*/
const inputValidation = (errordata) => {
  const inputField = errordata.input;
  const inputCustomMessage = errordata.custom;
  if (errordata.type === `email`) {
    const errorMessageEmail = inputCustomMessage
      ? inputCustomMessage
      : `Please enter a valid email address using the following format: example@yourdomain.com.`;
    inputField.setCustomValidity(`${errorMessageEmail}`);
  } else if (errordata.type === `phone`) {
    const errorMessagePhone = inputCustomMessage
      ? inputCustomMessage
      : `Please enter a valid phone number using the following format: 503-555-1313.`;
    inputField.setCustomValidity(`${errorMessagePhone}`);
  } else if (errordata.type === `address_zip`) {
    const errorMessageZip = inputCustomMessage
      ? inputCustomMessage
      : `Please enter a valid 5-digit zip code.`;
    inputField.setCustomValidity(errorMessageZip);
  } else {
    if (errordata.check === "hasValue") {
      inputField.setCustomValidity(`Please fill out this field.`);
    } else if (errordata.check === "minimumLength") {
      inputField.setCustomValidity(
        `Must be at least ${inputCustomMessage} characters.`
      );
    } else if (errordata.check === "allowedCharacters") {
      inputField.setCustomValidity(`${inputCustomMessage}`);
    } else if (errordata.check === "strictLength") {
      inputField.setCustomValidity(`${inputCustomMessage}`);
    } else {
      inputField.setCustomValidity("");
    }
  }
  // errordata.input.classList.add("invalidated");
};
/*----//  Select (Drop-down) Field: Validation Messaging   //----*/
const selectValidation = (errordata) => {
  const selectField = errordata.input;
  const selectFieldValidity = selectField.validity;
  if (!selectFieldValidity.valid) {
    if (selectFieldValidity.valueMissing) {
      selectField.setCustomValidity(`Please select an item in the list.`);
    } else {
      selectField.setCustomValidity(``);
    }
  }
  // console.log("wpro_debug__errodataSELECTVALIDATON__object");
  // console.log({ wpro_debug__errodataSELECTVALIDATON__object: errordata.input.validity });
};
/*----//  Textarea Field: Validation Messaging   //----*/
const textareaValidation = (errordata) => {
  console.log("wpro_debug__errordata_textareaValidation__object");
  console.log({ wpro_debug__errordata_textareaValidation__object: errordata });
  const textAreaField = errordata.input;
  const textAreaFieldValidity = textAreaField.validity;
  if (!textAreaFieldValidity.valid) {
    if (textAreaFieldValidity.valueMissing) {
      textAreaField.setCustomValidity(`Please fill out this field`);
    } else {
      textAreaField.setCustomValidity(``);
    }
  }
};
const setValidation = (errordata) => {
  if (errordata.result) {
    const fieldTagType = errordata.input.tagName.toLowerCase();
    errordata.input.classList.add("invalidated");
    if (fieldTagType === "input") {
      inputValidation(errordata);
    } else if (fieldTagType === `select`) {
      selectValidation(errordata);
    } else if (fieldTagType === `textarea`) {
      textareaValidation(errordata);
    } else {
      console.warn(`Unknown form field tag type: ${fieldTagType}`);
    }
  } else {
    errordata.input.setCustomValidity(``);
  }
};

const runCheck = (tests) => {
  /*----//  Checking and filtering failed validations  //----*/
  const getFailedChecks = tests.filter((test) => (test.fail ? test : ""));
  return getFailedChecks;
};

const inputChecks = {
  hasValue: (input, type) => {
    let checkFieldValue;
    const inputvalue = input.value;
    let valueMissing = input.validity.valueMissing;
    if (!inputvalue && !valueMissing) {
      valueMissing = true;
    }
    try {
      checkFieldValue = validationResult(
        "hasValue",
        valueMissing,
        type,
        input,
        ""
      );
      // setValidation(checkFieldValue);
      if (valueMissing) {
        throw new Error(checkFieldValue);
      } else {
        return checkFieldValue;
      }
    } catch (error) {
      reportFailed(input, checkFieldValue);
      if (checkFieldValue.result) {
        checkFieldValue.fail = true;
      }
      return checkFieldValue;
    }
  },
  minimumLength: (input, minimum, type, message) => {
    let checkMinLength;
    const inputvalue = input.value;
    const inputvaluelength = inputvalue.length;
    let belowMinimum = input.validity.tooShort;
    if (inputvaluelength < minimum && inputvaluelength > 0 && !belowMinimum) {
      belowMinimum = true;
    }
    try {
      checkMinLength = validationResult(
        "minimumLength",
        belowMinimum,
        type,
        input,
        message
      );
      // setValidation(checkMinLength);
      if (belowMinimum) {
        throw new Error(checkMinLength);
      } else {
        return checkMinLength;
      }
    } catch (error) {
      reportFailed(input, checkMinLength);
      if (checkMinLength.result) {
        checkMinLength.fail = true;
      }
      return checkMinLength;
    }
  },
  maximumLength: (input, maximum, type, message) => {
    let checkMaxLength;
    const inputvalue = input.value;
    const inputvaluelength = inputvalue.length;
    let aboveMaximum = input.validity.tooLong;
    if (inputvaluelength > maximum && inputvaluelength > 0 && !aboveMaximum) {
      aboveMaximum = true;
    }
    try {
      checkMaxLength = validationResult(
        "maximumLength",
        aboveMaximum,
        type,
        input,
        minimum
      );
      if (aboveMaximum) {
        const trimInputValue = inputvalue.substring(0, limit);
        input.value = trimInputValue;
        throw new Error(checkMaxLength);
      } else {
        return checkMaxLength;
      }
    } catch (error) {
      reportFailed(input, checkMaxLength);
      if (checkMaxLength.result) {
        checkMaxLength.fail = true;
      }
      return checkMaxLength;
    }
  },
  strictLength: (input, limit, message, type) => {
    let checkLimitLength;
    const inputvalue = input.value;
    const inputvaluelength = inputvalue.length;
    let outsideLimit = input.validity.tooLong
      ? input.validity.tooLong
      : input.validity.tooShort;
    if (inputvaluelength !== limit && inputvaluelength > 0 && !outsideLimit) {
      outsideLimit = true;
    }
    try {
      checkLimitLength = validationResult(
        "strictLength",
        outsideLimit,
        type,
        input,
        message
      );
      // setValidation(checkLimitLength);
      if (outsideLimit) {
        // const trimInputValue = inputvalue.substring(0, limit);
        // input.value = trimInputValue;
        throw new Error(checkLimitLength);
      } else {
        return checkLimitLength;
      }
    } catch (error) {
      reportFailed(input, checkLimitLength);
      if (checkLimitLength.result) {
        checkLimitLength.fail = true;
      }
      return checkLimitLength;
    }
  },
  allowedCharacters: (input, pattern, message, type) => {
    let checkAllowedCharacters;
    const inputvalue = input.value;
    const formatCheckPattern = pattern;
    let formatMisMatch = input.validity.typeMismatch;
    if (!formatCheckPattern.test(inputvalue) && !formatMisMatch) {
      formatMisMatch = true;
    }
    try {
      checkAllowedCharacters = validationResult(
        "allowedCharacters",
        formatMisMatch,
        type,
        input,
        message
      );
      // setValidation(checkAllowedCharacters);
      if (formatMisMatch) {
        throw new Error(checkAllowedCharacters);
      } else {
        return checkAllowedCharacters;
      }
    } catch (error) {
      reportFailed(input, checkAllowedCharacters);
      checkAllowedCharacters.fail = true;
      return checkAllowedCharacters;
    }
  },
  generalCheck: (input) => {
    let checkGeneral;
    const inputvalue = input.value;
    let inputInvalid = !input.validity.valid;
    try {
      checkGeneral = validationResult(
        "generalCheck",
        inputInvalid,
        "",
        input,
        inputvalue
      );
      if (inputInvalid) {
        throw new Error(checkGeneral);
      } else {
        return checkGeneral;
      }
    } catch (error) {
      reportFailed(input, checkGeneral);
      if (checkGeneral.result) {
        checkGeneral.fail = true;
      }
      return checkGeneral;
    }
  },
  email: {
    formatCheck: (input) => emailFormatCheck(input),
  },
};

const checkEmail = (inputEl, type) => {
  /**----//
  ------------------------------------------🧿--🧿
Email
Cannot be empty
Must be at least 5 characters
Can only include letters, numbers, hyphen, underscore, period and a single '@'.
Must include @ symbol and period
Cannot include “@.” or “.@”
Cannot start with @ symbol
Can only include one @
Cannot contain spaces

  ------------------------------------------🧿--🧿
  //----*/

  const checkMissingValue = inputChecks.hasValue(inputEl, type);
  const checkEmailLength = inputChecks.minimumLength(inputEl, 5, type);
  const checkEmailFormat = inputChecks.allowedCharacters(
    inputEl,
    /^(?!.*\.\.)(?!.*\.\@)(?!\.)[a-zA-Z0-9._-]+@(?!\.)[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    ``,
    type
  );
  const runValidation = runCheck([
    checkMissingValue,
    checkEmailLength,
    checkEmailFormat,
  ]);
  if (runValidation.length === 0) {
    validField(inputEl);
  }
  return runValidation;
};

const checkPhone = (inputEl, type) => {
  /**----//
  ------------------------------------------🧿--🧿
  
Cannot be empty
Must be at least 9 characters
Can only include digits 0-9 
Dashes are optional but if included, must be xxx-xxx-xxxx format
  
  ------------------------------------------🧿--🧿
  //----*/
  const checkMissingValue = inputChecks.hasValue(inputEl, type);
  const checkPhoneLength = inputChecks.minimumLength(inputEl, 10, type);
  const checkPhoneFormat = inputChecks.allowedCharacters(
    inputEl,
    /^\d{3}(-)?\d{3}(-)?\d{4}$/,
    ``,
    type
  );
  const runValidation = runCheck([
    checkMissingValue,
    checkPhoneLength,
    checkPhoneFormat,
  ]);
  if (runValidation.length === 0) {
    validField(inputEl);
  }
  return runValidation;
};

const checkZip = (inputEl, type) => {
  /**----//
  ------------------------------------------🧿--🧿
  
Cannot be empty
Must be 5 digits
Can only include digits 0-9 

  ------------------------------------------🧿--🧿
  //----*/

  const checkMissingValue = inputChecks.hasValue(inputEl, type);
  const checkZipLength = inputChecks.strictLength(
    inputEl,
    5,
    `Please enter a valid 5-digit zip code.`,
    type
  );
  const checkZipFormat = inputChecks.allowedCharacters(
    inputEl,
    /^[0-9]+$/,
    `Please enter a valid 5-digit zip code.`,
    type
  );
  const runValidation = runCheck([
    checkMissingValue,
    checkZipLength,
    checkZipFormat,
  ]);

  if (runValidation.length === 0) {
    validField(inputEl);
  }
  return runValidation;
};

const checkGeneral = (inputEl, type) => {
  if (inputEl.required) {
    const checkMissingValue = inputChecks.hasValue(inputEl, type);
    const checkGeneral = inputChecks.generalCheck(inputEl);
    const runValidation = runCheck([checkMissingValue, checkGeneral]);
    console.log("wpro_debug__runValidation__length__object");
    console.log({
      wpro_debug__runValidation__length__object: runValidation.length,
    });
    if (runValidation.length === 0) {
      validField(inputEl);
    }
    return runValidation;
  }
};

/**----//
------------------------------------------🧿--🧿
@type {Array}
@const formValidationHandler will be an array

------------------------------------------🧿--🧿
//----*/
const formValidationHandler = (field, input) => {
  /*----//  Sanitize Values  //----*/
  input.value = input.value.trim();
  let errors = [];
  /*----//  Start Validations  //----*/
  switch (field) {
    case "email":
      input.validity;
      const emailValidationChecks = checkEmail(input, field);
      if (emailValidationChecks) {
        errors = emailValidationChecks;
      }
      break;
    case "address_zip":
      input.validity;
      const zipCodeValidationChecks = checkZip(input, field);
      if (zipCodeValidationChecks) {
        errors = zipCodeValidationChecks;
      }
      break;
    case "phone":
      input.validity;
      const phoneValidationChecks = checkPhone(input, field);
      if (phoneValidationChecks) {
        errors = phoneValidationChecks;
      }
      break;
    default:
      input.validity;
      const generalValidationChecks = checkGeneral(input, field);
      if (generalValidationChecks) {
        errors = generalValidationChecks;
      }
      break;
  }
  if (errors.length > 0) {
    errors.forEach((error) => {
      setValidation(error);
    });
  } else {
    input.setCustomValidity("");
  }
  return errors;
};

const preSubmitValidate = (form) =>
  new Promise((resolve, reject) => {
    // const formInput = form.querySelectorAll("input");
    let errors = [];
    /*----//  Get Inputs Fields  //----*/
    const formInput = form.querySelectorAll("input");
    /*----//  Get Select Fields  //----*/
    const formSelect = form.querySelectorAll("select");
    /*----//  Get Textarea Fields  //----*/
    const formTextArea = form.querySelectorAll("textarea");
    /*----//  Array of our form fields  //----*/
    const formFields = [formInput, formSelect, formTextArea];
    /*----//  Add validation  //----*/
    formFields.forEach((fields) => {
      fields.forEach((fieldEl) => {
        const oldfield = fieldEl.dataset.inputField;
        formValidationHandler(oldfield, fieldEl);
      });
    });
    if (errors.length > 0) {
      reject({
        message: `Errors ${errors.length} Found`,
        info: errors,
      });
    } else {
      resolve({
        message: `Validation passed with ${errors.length} errors.`,
        info: true,
      });
    }
  });
const form_validation = { formValidationHandler, preSubmitValidate };

export default form_validation;
